import React, { PropsWithChildren } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { FullWindowOverlay } from 'react-native-screens';

import { common } from '@/styles/styles';
import { isIos } from '@/utils/constants-platform-specific';

type CustomFullWindowOverlayProps = PropsWithChildren<{
    unstable_accessibilityContainerViewIsModal?: boolean;
}>;

/**
 * `FullWindowOverlay` from react-native-screens is iOS-only: on Android it logs a warning and
 * falls back to a plain `View` with no absolute positioning or z-index. This wrapper provides a
 * proper Android fallback so overlays render above all other content on both platforms
 */
export const CustomFullWindowOverlay = ({
    children,
    unstable_accessibilityContainerViewIsModal,
}: CustomFullWindowOverlayProps) => {
    const { width, height } = useWindowDimensions();

    if (isIos) {
        return (
            <FullWindowOverlay unstable_accessibilityContainerViewIsModal={unstable_accessibilityContainerViewIsModal}>
                {/* makes sure all children are tappable */}
                <View style={StyleSheet.absoluteFill} pointerEvents="box-none">
                    {children}
                </View>
            </FullWindowOverlay>
        );
    }
    return (
        <View pointerEvents="box-none" style={[StyleSheet.absoluteFill, { width, height }, common.zIndex999]}>
            {children}
        </View>
    );
};
